module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-container is-flex"
  }, [_c('progress', {
    class: ['progress', _vm.type ? ("is-" + _vm.type) : '', _vm.size ? ("is-" + _vm.size) : ''],
    attrs: {
      "value": _vm.value,
      "max": _vm.max
    }
  }), _vm._v(" "), (_vm.showLabel) ? _c('span', [_vm._v(_vm._s(_vm.percentage + '%'))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f472827e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-progress-bar/src/ProgressBar.vue
// module id = 170
// module chunks = 34